import { BaseFilterButton } from 'components/base-table/filters';
import { Button, ChakraSelect, FormControl, FormLabel, HStack, Stack, useDisclosure } from 'design-system';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect, useState } from 'react';
import { OrderSource, ORDER_SOURCES, ORDER_SOURCE_META } from '../utils/order-source';

type TOption = { value: OrderSource; label: string };

const options: TOption[] = ORDER_SOURCES.map((source) => ({ value: source, label: ORDER_SOURCE_META[source].label }));

/** `?source=marketplace|classic` on the CMS orders list; a change goes back to page 1. */
export const OrderSourceFilterButton = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const current = options.find((option) => option.value === params.source) ?? null;
  const [value, setValue] = useState<TOption | null>(current);

  useEffect(() => {
    setValue(current);
  }, [params.source]);

  const handleClose = () => {
    onClose();
    setValue(current);
  };

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setPageParams({ ...params, source: value?.value, page: 1 });
    onClose();
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={Boolean(current)}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' minW='240px' onSubmit={onSubmit}>
          <FormControl>
            <FormLabel>Source</FormLabel>
            <ChakraSelect
              id='source'
              options={options}
              isClearable
              isSearchable={false}
              value={value}
              onChange={(option) => setValue((option as TOption | null) ?? null)}
            />
          </FormControl>

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' isDisabled={value?.value === current?.value}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
